/** @format */
import Loader from '../../../../Components/Loaders/Loader'
import Checkbox from '../../../../Components/Checkbox/Checkbox'
import React from 'react'

export const ChequeTypeInvestmentProducts = ({
  disabled,
  isBusy,
  selectedChequeType,
  setSelectedChequeType,
  prefix,
}) => {
  const handleCheckChequeTypeInvestmentProducts = (
    investmentProducts,
    checkValue
  ) => {
    const com = [...selectedChequeType?.investmentProducts].map(comm => {
      if (comm.id === investmentProducts.id) {
        return { ...comm, checked: checkValue }
      }
      return comm
    })

    setSelectedChequeType({ ...selectedChequeType, investmentProducts: com })
  }

  return (
    <div className="px-4">
      {isBusy ? (
        <Loader />
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {selectedChequeType?.investmentProducts.map(investmentProducts => (
            <li
              key={investmentProducts.id}
              style={{ listStyle: 'none' }}
              className=" d-flex align-items-center"
            >
              <Checkbox
                id={`${prefix ? prefix : 'com'}-${investmentProducts.id}`}
                checked={investmentProducts.checked}
                disabled={disabled}
                margined
                onCheck={c => {
                  handleCheckChequeTypeInvestmentProducts(investmentProducts, c)
                }}
              />
              <label
                htmlFor={`${prefix ? prefix : 'com'}-${investmentProducts.id}`}
                className={`fw-normal ms-2 cursor-pointer ${
                  investmentProducts.checked ? 'text-primary fw-bold' : ''
                }`}
              >
                {investmentProducts.description}
              </label>
            </li>
          ))}
        </div>
      )}
    </div>
  )
}
